var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyLimits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#27AE60",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9453 18.2109C26.884 18.4441 23.0769 20.0209 20.04 22.728L24.5436 27.2313C25.5346 26.8794 26.6008 26.6872 27.711 26.6872C28.8461 26.6872 29.9354 26.8879 30.9453 27.2552V18.2109Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0396 30.1534L43.5587 22.3808C40.5908 19.8861 36.9392 18.434 33.0547 18.2109V28.3387C33.799 28.8474 34.4675 29.459 35.0396 30.1534Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36.1758V37.2305H18.2188V36.1758C18.2188 32.8445 19.9439 29.9089 22.5474 28.2146L18.5486 24.2158C15.6084 27.5142 14 31.7211 14 36.1758Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4067 37.2303H49.9999V36.1757C49.9999 34.642 49.8084 33.1379 49.4388 31.6899L44.4067 37.2303Z",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9995 37.2656C30.8726 37.2656 29.813 37.7045 29.0162 38.5013C27.3716 40.1462 27.3716 42.8225 29.0162 44.4674C29.813 45.2642 30.8726 45.7031 31.9995 45.7031C33.1262 45.7031 34.1858 45.2642 34.9826 44.4674C36.6275 42.8225 36.6275 40.1462 34.9826 38.5013C34.1858 37.7045 33.1262 37.2656 31.9995 37.2656Z",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5132 23.4492L32.6455 35.1892C34.0916 35.3348 35.4327 35.9684 36.4742 37.0099C37.541 38.0767 38.1455 39.433 38.29 40.8282L50.0001 27.9347V23.4492H45.5132Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyLimits);
export default __webpack_public_path__ + "static/media/weekly-limits.ca264f9c448401e2afdc0ba8c0cedcf3.svg";
export { ForwardRef as ReactComponent };